// Web mock for @react-native-async-storage/async-storage using localStorage
const AsyncStorage = {
  getItem: async (key: string): Promise<string | null> => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem: async (key: string, value: string): Promise<void> => {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Storage full or unavailable
    }
  },
  removeItem: async (key: string): Promise<void> => {
    try {
      localStorage.removeItem(key);
    } catch {
      // Ignore
    }
  },
  mergeItem: async (key: string, value: string): Promise<void> => {
    try {
      const existing = localStorage.getItem(key);
      if (existing) {
        const merged = { ...JSON.parse(existing), ...JSON.parse(value) };
        localStorage.setItem(key, JSON.stringify(merged));
      } else {
        localStorage.setItem(key, value);
      }
    } catch {
      // Ignore
    }
  },
  clear: async (): Promise<void> => {
    try {
      localStorage.clear();
    } catch {
      // Ignore
    }
  },
  getAllKeys: async (): Promise<string[]> => {
    try {
      return Object.keys(localStorage);
    } catch {
      return [];
    }
  },
  multiGet: async (keys: string[]): Promise<[string, string | null][]> => {
    try {
      return keys.map(key => [key, localStorage.getItem(key)]);
    } catch {
      return keys.map(key => [key, null]);
    }
  },
  multiSet: async (keyValuePairs: [string, string][]): Promise<void> => {
    try {
      keyValuePairs.forEach(([key, value]) => localStorage.setItem(key, value));
    } catch {
      // Ignore
    }
  },
  multiRemove: async (keys: string[]): Promise<void> => {
    try {
      keys.forEach(key => localStorage.removeItem(key));
    } catch {
      // Ignore
    }
  },
  multiMerge: async (keyValuePairs: [string, string][]): Promise<void> => {
    for (const [key, value] of keyValuePairs) {
      await AsyncStorage.mergeItem(key, value);
    }
  },
};

export default AsyncStorage;
